import React from 'react';
import { Link } from 'react-router-dom';

const GameCard = ({ title, description, imageUrl, link, imageAlt }) => {
  return (
    <Link to={link} className="block h-full">
      <div className="bg-white rounded-lg shadow-sm border border-neutral-200 hover:shadow-md transition-shadow overflow-hidden h-full flex flex-col">
        <div className="aspect-w-16 aspect-h-9 bg-neutral-100">
          <img
            src={imageUrl}
            alt={imageAlt}
            className="object-cover w-full h-full"
          />
        </div>
        <div className="p-4 flex-1 flex flex-col">
          <h3 className="text-lg font-semibold mb-2">{title}</h3>
          <p className="text-sm text-neutral-600 flex-1">{description}</p>
        </div>
      </div>
    </Link>
  );
};

export default GameCard; 